import { type CardStylingDataStructure } from 'javascripts/shared-types';
import {
  type CardLayoutModelConstructorType,
  type CardLayoutModelType,
} from './types';
import type Query from 'components/framework/Query';
import { type CardStylingTypesEnum_value } from 'components/framework/models/generated/types';

export default abstract class CardStyling {
  static type: CardStylingTypesEnum_value;
  static title: string;

  /**
   * The attributes to select on the model.
   */
  static attributesForModel(
    modelClass: CardLayoutModelConstructorType
  ): string[] {
    return [];
  }

  /**
   * The subqueries to select on the model.
   */
  static subqueriesForModel(modelClass: CardLayoutModelConstructorType) {
    return {};
  }

  static availableForModel(
    modelClass: CardLayoutModelConstructorType
  ): boolean {
    const fields = this.attributesForModel(modelClass);
    const subqueries = this.subqueriesForModel(modelClass);

    return (
      fields.every(field => modelClass.hasField(field)) &&
      Object.keys(subqueries).every(field => modelClass.hasField(field))
    );
  }

  constructor(public modelClass: CardLayoutModelConstructorType) {}

  buildScope<T extends Query<CardLayoutModelConstructorType, any>>(
    query: T
  ): T {
    if (
      !(this.constructor as typeof CardStyling).availableForModel(
        this.modelClass
      )
    ) {
      return query;
    }

    const fields = (this.constructor as typeof CardStyling).attributesForModel(
      this.modelClass
    );
    const includes = (
      this.constructor as typeof CardStyling
    ).subqueriesForModel(this.modelClass);

    return query.select(fields).deepMerge(includes);
  }

  exampleCardStyling(): CardStylingDataStructure {
    return {};
  }

  cardStyling(record: CardLayoutModelType): CardStylingDataStructure {
    return {};
  }
}
